import { render } from "./TimeCore.vue?vue&type=template&id=627a977c&ts=true"
import script from "./TimeCore.vue?vue&type=script&lang=ts"
export * from "./TimeCore.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__